module.exports = __webpack_public_path__ + "img/凭证账.66930f51.png";